module.exports = __webpack_public_path__ + "img/lotus.97bccd04.png";